import img1 from '../../assets/images/gdbg.jpg';
import img2 from '../../assets/images/gdbg.jpg';
import PageBanner from '../common/PageBanner';
import './BannerGiveawayDetails.scss';

function BannerGiveawayDetails() {
  const slides = [
    {
      image: {
        src: img1
      },
      html: (
        <div className="h-full flex align-items-center jc-center">
        </div>
      )
    },
    {
      image: {
        src: img2
      },
      html: (
        <div className="h-full flex align-items-center jc-center">
        </div>
      )
    }
  ];

  return (
    <div className="gd-details-banner">
      <PageBanner slides={slides} />
    </div>
  );
}

export default BannerGiveawayDetails;
